/* eslint-disable eqeqeq */
import { Chip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React from "react";

const useStyles = makeStyles((theme) => ({
  betaChip: {
    backgroundColor: `${theme.palette.weesu.light_blue} !important`,
    color: `${theme.palette.common.white} !important`,
    border: `1px solid ${theme.palette.weesu.light_blue} !important`,
    marginLeft: "5px !important",
  },
}));

function BetaChip() {
  const classes = useStyles();
  return <Chip size="small" label="beta" className={clsx(classes.betaChip)} />;
}

export default BetaChip;
